import React, { createContext, useContext, useState, useCallback, useRef } from "react";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, message: "", title: "" });
  const resolveRef = useRef(null);

  const confirm = useCallback((message, title = "Confirmation") => {
    setState({ isOpen: true, message, title });
    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  }, []);

  const handleConfirm = () => {
    setState((s) => ({ ...s, isOpen: false }));
    resolveRef.current?.(true);
  };

  const handleCancel = () => {
    setState((s) => ({ ...s, isOpen: false }));
    resolveRef.current?.(false);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state.isOpen && (
        <div className="fixed inset-0 bg-black/45 flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-xl p-8 w-full max-w-[420px] shadow-2xl animate-[fadeIn_0.15s_ease]">
            <h3 className="text-lg font-bold text-gray-900 mb-3">{state.title}</h3>
            <p className="text-gray-600 leading-relaxed mb-6">{state.message}</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={handleCancel}
                className="px-5 py-2.5 rounded-lg text-sm font-semibold bg-gray-100 text-gray-600 border-none cursor-pointer hover:bg-gray-200 transition-colors"
              >
                Annuler
              </button>
              <button
                onClick={handleConfirm}
                className="px-5 py-2.5 rounded-lg text-sm font-semibold bg-gradient-to-r from-red-500 to-pink-500 text-white border-none cursor-pointer hover:opacity-90 transition-opacity"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm must be used within ConfirmProvider");
  return ctx.confirm;
}
